import { render, staticRenderFns } from "./OneDriveAttachmentItem.vue?vue&type=template&id=3bf8208a&scoped=true&"
import script from "./OneDriveAttachmentItem.vue?vue&type=script&lang=js&"
export * from "./OneDriveAttachmentItem.vue?vue&type=script&lang=js&"
import style0 from "./OneDriveAttachmentItem.vue?vue&type=style&index=0&id=3bf8208a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf8208a",
  null
  
)

export default component.exports